import { useTranslate } from '@growtherapy/i18n';
import { Button, ButtonProps } from '@growtherapy/sprout-ui';

import { ProviderLoginWrapper } from './ProviderLogin';

function FooterContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className='flex items-center justify-end gap-4 shrink-0 py-5 px-350 sm:px-14 sm:py-4 border-t rebrand:border-border-default'>
      {children}
    </div>
  );
}

function PrimaryButton(props: ButtonProps) {
  return <Button use='primary' className='rebrand:border max-sm:flex-grow mx-0' {...props} />;
}

function ProviderLogin() {
  return <ProviderLoginWrapper className='flex-shrink-0' />;
}

export type FooterDefaultProps = {
  isDisabled: boolean;
  onEnterWaitingRoom: () => void;
};

function Default({ isDisabled, onEnterWaitingRoom }: FooterDefaultProps) {
  const t = useTranslate();
  return (
    <FooterContainer>
      <ProviderLogin />
      <PrimaryButton disabled={isDisabled} onClick={onEnterWaitingRoom}>
        {t('telehealth-core:introRoom.enterWaitingRoom')}
      </PrimaryButton>
    </FooterContainer>
  );
}

export type FooterPIIVerificationProps = {
  isDisabled: boolean;
  isSubmitting: boolean;
  onSubmit: () => void;
};

function PIIVerification({ isDisabled, isSubmitting, onSubmit }: FooterPIIVerificationProps) {
  const t = useTranslate();
  return (
    <FooterContainer>
      <ProviderLogin />
      <PrimaryButton disabled={isDisabled} loading={isSubmitting} onClick={onSubmit}>
        {t('telehealth-core:core.continue')}
      </PrimaryButton>
    </FooterContainer>
  );
}

export type FooterRequiredAgreementsReviewProps = {
  isDisabled: boolean;
  isSubmitting: boolean;
  onSubmit: () => void;
};

function RequiredAgreementsReview({ isDisabled, isSubmitting, onSubmit }: FooterRequiredAgreementsReviewProps) {
  const t = useTranslate();
  return (
    <FooterContainer>
      <ProviderLogin />
      <PrimaryButton disabled={isDisabled} loading={isSubmitting} onClick={onSubmit}>
        {t('telehealth-core:introRoom.enterWaitingRoom')}
      </PrimaryButton>
    </FooterContainer>
  );
}

export const FooterContent = {
  Default,
  PIIVerification,
  RequiredAgreementsReview,
};
